import { SettingsRepository } from "../repositories/SettingsRepository";
import { VerificationLivenessSession } from "../entities/VerificationUploadResult";

export class CreateVerificationLivenessSession {
	constructor(private repository: SettingsRepository) {}

	execute(): Promise<VerificationLivenessSession> {
		return this.repository.createVerificationLivenessSession();
	}
}
